export const WITHDRAW_SETTINGS_FRAME = '@FRAME/Creator/Withdraw/withdraw_settings';
export const WITHDRAW_SETTINGS_PAGE = '@PAGE/Creator/Withdraw/withdraw_settings';
export const WITHDRAW_SETTINGS_TAB = '@TAB/Creator/Withdraw/withdraw_settings';

export const WITHDRAW_CREWS_FRAME = '@FRAME/Creator/Withdraw/withdraw_crews';
export const WITHDRAW_CREWS_PAGE = '@PAGE/Creator/Withdraw/withdraw_crews';
export const WITHDRAW_CREWS_TAB = '@TAB/Creator/Withdraw/withdraw_crews';

export const WITHDRAW_APPROVE_FRAME = '@FRAME/Creator/Withdraw/withdraw_approve';
export const WITHDRAW_APPROVE_PAGE = '@PAGE/Creator/Withdraw/withdraw_approve';
export const WITHDRAW_APPROVE_TAB = '@TAB/Creator/Withdraw/withdraw_approve';

export const WITHDRAW_RESULT_FRAME = '@FRAME/Creator/Withdraw/withdraw_result';
export const WITHDRAW_RESULT_PAGE = '@PAGE/Creator/Withdraw/withdraw_result';
export const WITHDRAW_RESULT_TAB = '@TAB/Creator/Withdraw/withdraw_result';

export const CREW_WITHDRAW_FRAME = '@FRAME/Creator/Withdraw/crew_withdraws';
export const CREW_WITHDRAW_PAGE = '@PAGE/Creator/Withdraw/crew_withdraws';
export const CREW_WITHDRAW_TAB = '@TAB/Creator/Withdraw/crew_withdraws';

export const account_history_fields = [
  'type',
  'number',
  'owner',
  'bank',
  'user_name',
  'phone',
  'company_name',
  'business_license_number',
  'parent_name',
  'parent_birth',
  'nationality',
  'bank_code',
];

export const WITHDRAW_EXCEL_HEADER = [
  'No.',
  '스토어 ID',
  '상태',
  '검증여부',
  '법정대리인 검증여부',
  '유형',
  '상점이름',
  '마플샵제작배송 상품 정산액',
  '디지털/전자책 정산액',
  '마플샵배송 상품 정산액',
  '멤버십 정산액',
  '크리에이터 디자인 정산액',
  '총 정산액', // POD+디지털+입고+멤버십 정산액 합계
  '부가세',
  '소득세',
  '주민세',
  '총세금',
  '원천징수 반영금액',
  '크리에이터배송 상품 or 멤버십 총 매출', // 3P || 멤커후 총 수수료
  '마플샵 수수료(크 or 멤)', // 3P || 멤커후 판매 수수료
  'PG 수수료(크 or 멤)', // 3P || 멤커후 PG 수수료
  '총 수수료(크 or 멤)', //  판매 수수료 + PG 수수료
  '정산액(크 or 멤)', // 촏 매출 - (총 수수료)
  '최종 입금액', // 원천징수 반영금액 + 크리에이터 정산액
  '소득자',
  '주민번호',
  '은행명',
  '계좌번호',
  '예금주',
  '사업자번호',
  '사업자 상호명',
  '대표자명',
  '사업장 주소',
  '업종',
  '업태',
  '담당자이메일',
  '승인/취소',
  '취소사유',
];

export const INICIS_SUBMALL_EXCEL_HEADER = [
  '파트너 아이디',
  '파트너 이름 *',
  '담당자 이름 *',
  '담당자 이메일 *',
  '담당자 연락처',
  '기본 계약 아이디 *',
  '은행 코드 *',
  '계좌 번호 *',
  '예금주명 *',
  '통화 *',
  '메모',
  '태그',
  '파트너 유형 *',
  '과세·소득 유형',
  '사업자 등록번호',
  '대표자명',
  '회사명',
  '사업장 주소',
  '업종',
  '업태',
  '대표자 생년월일',
];

export const PORTONE_WITHDRAW_EXCEL_HEADER = [
  '정산 유형 *',
  '파트너 아이디 *',
  '정산일 *',
  '정산 금액 *',
  '메모',
];

export const WITHDRAW_DATE = '11';

export const MSG = {
  check_bank_account_filled_message:
    '<h3>출금 불가</h3>필요한 계좌정보 내용이 모두 기입되지 않았습니다. 계좌정보 페이지에서 내용을 기입해 주세요.',
  check_bank_user_name:
    '<h3>출금 불가</h3>크리에이터님의 실명을 입력해 주세요. 계좌정보 페이지에서 내용을 기입해 주세요.',
  check_bank_code:
    '<h3>출금 불가</h3>은행 계좌 코드가 누락되었습니다. 계좌정보 페이지에서 계좌 정보를 다시한번 기입해 주세요.',
  check_tax_paper_message_title: '세금계산서 발행',
  check_tax_paper_message: `사업자 크리에이터는 출금 신청 완료 후, 당월 10일까지 세금계산서를 발행해주셔야 합니다.
<br />세금계산서가 기간 내 발행되지 않거나 오류가 있는 경우, 이번 달 출금 신청은 자동 취소됩니다.
<br /><br />※ 세금계산서 발행 대상 금액 = 마플샵제작배송 상품 + 디지털/전자책 + 마플샵배송 상품 정산 금액
<br />※ 세금계산서 발행 제외 금액: 크리에이터배송 상품, 멤버십/커미션/후원 정산 금액
<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.marppleshop.help/ko/articles/%EC%82%AC%EC%97%85%EC%9E%90-%EC%84%B8%EA%B8%88%EA%B3%84%EC%82%B0%EC%84%9C-%EB%B0%9C%ED%96%89%ED%95%98%EA%B8%B0-e37a392b#%EB%B0%9C%ED%96%89-%EC%A0%9C%EC%99%B8-%EA%B8%88%EC%95%A1">사업자 세금계산서 발행 가이드</a>`,
  check_bank_account_accuracy_message:
    '잠깐! 계좌 정보는 정확히 입력하셨나요?<br/>계좌 정보가 잘못된 경우 출금 신청은 취소되며<br/>재신청하는 출금 신청은 다음 달에 정산 진행됩니다.',
  check_amount_over: '입력한 입금액이 정산 금액보다 많습니다. 계속 진행하려면 확인을 눌러주세요.',
};

export const WITHDRAW_TYPE = {
  integrated: 'integrated',
  separate: 'separate',
};

export const STORE_TYPE = {
  seller: 'seller',
  crew: 'crew',
};

export const MINIMUM_WITHDRAW_AMOUNT = 10000;

/**
 * Inicis 증권코드와 현재 사용중인 Impt의 증권코드가 달라 하드코딩으로 변경, 이니시스 웹메뉴얼 참고
 */
export const InicisBankCodeMap: Record<string, string> = {
  209: 'D1', // 유안타증권
  218: 'D2', //현대증권
  227: 'DQ', // 다올투자증권
  230: 'D3', // 미래에셋증권
  238: 'D3', // 미래에셋증권
  240: 'DH', // 삼성증권
  243: 'D4', // 한국투자증권
  261: 'DI', // 교보증권
  262: 'D6', // 하이투자증권
  263: 'D7', // 현대차증권(portone), HMC투자증권(inicis)
  264: 'DJ', // 키움증권
  266: 'D8', // SK증권
  267: 'D9', // 대신증권
  269: 'DM', // 한화투자증권(portone), 한화증권(inicis)
  270: 'DA', // 하나대투증권
  278: 'DB', // 신한투자증권(portone), 굿모닝신한증권(inicis)
  289: 'DN', // NH투자증권(portone), NH증권(inicis)
};
